import MetisMenu from "metismenujs";
import { HeaderBase } from "@Base/Site/HeaderBase";

import "./Header.scss";

export class Header extends HeaderBase
{
	constructor()
	{
		super();
		this.Initialize();
	}

	public Initialize(): void
	{
		super.Initialize();
	}

	public MenuMobileOpen = (): void =>
	{
		const mobileMenu = document.querySelector("#mobileMenu");
		const topMenu = document.querySelector("#topMenu");

		if (mobileMenu !== null)
		{
			this.MobileMenu = document.querySelector("#mobileMenu") as HTMLElement;
		}

		if (topMenu !== null)
		{
			this.TopMenu = document.querySelector("#topMenu") as HTMLElement;
		}

		if (this.MobileMenu !== null && this.TopMenu !== null)
		{
			this.MobileMenu.appendChild(this.TopMenu);
		}

		const unwrapParents = document.querySelectorAll(".nav-unwrap__parent");

		if (unwrapParents.length > 0)
		{
			unwrapParents.forEach((unwrappedParent) =>
			{
				const unwrap = unwrappedParent.querySelectorAll(".nav-unwrap__child");

				if (unwrap.length > 0)
				{
					unwrap.forEach((unwrappedChild) =>
					{
						const unwrappedClone = unwrappedChild.cloneNode(true) as HTMLElement;
						unwrappedClone.classList.add("d-lg-none", "nav-unwrap__clone");
						unwrappedParent.after(unwrappedClone);
					});
				}
			});
		}

		this.MobileMenuInstance = new MetisMenu("#menu");
	};
}